/**
 * Puente entre la capa HTTP y el estado de sesión.
 *
 * `api-client` necesita leer el access token y, ante un 401, pedir un refresh.
 * Para evitar un ciclo de importaciones (store -> auth.api -> api-client -> store)
 * el cliente HTTP no conoce el store: la aplicación registra un proveedor que
 * implementa esta interfaz al arrancar (`registerSessionProvider`).
 */

export interface SessionProvider {
  /** Access token vigente, o `null` si no hay sesión. */
  getAccessToken(): string | null;

  /** Indica si existe un refresh token con el que intentar renovar. */
  canRefresh(): boolean;

  /**
   * Renueva la sesión.
   * Debe ser idempotente: las llamadas concurrentes comparten una única request.
   * @returns `true` si la sesión se renovó correctamente.
   */
  refresh(): Promise<boolean>;

  /** Notifica que la sesión murió y el usuario debe volver al login. */
  onSessionExpired(): void;
}

let provider: SessionProvider | null = null;

export function registerSessionProvider(next: SessionProvider): void {
  provider = next;
}

export function unregisterSessionProvider(): void {
  provider = null;
}

export function getSessionProvider(): SessionProvider | null {
  return provider;
}
